import {AdminApi} from "../service";

export async function getAllQrHistories(body) {
  return await AdminApi.get(`/histories/change/qr-code`, {
    params: {
      start: body.start,
      end: body.end,
    }
  });
}